import { Text, View } from "@react-pdf/renderer";
import SectionHeader from "./SectionHeader";
import ProductDetails from "./ProductDetails";
import { Product } from "models/Product";
import { color } from "../styles";
import { useLocalization } from "../localization/LocalizationContext";

type ProductsSectionProps = { products: Product[] };

const ProductsSection: React.FC<ProductsSectionProps> = (props) => {
  const { products } = props;
  const { strings } = useLocalization();
  const t = strings.productsSection;

  return (
    <View>
      <SectionHeader>
        <Text>{t.title}</Text>
      </SectionHeader>

      {products.map((product, index) => (
        <View
          key={product.id}
          wrap={false}
          style={{
            fontSize: 12,
            paddingBottom: 10,
            marginBottom: 10,
            // Hide border on last item
            ...(index !== products.length - 1 && {
              borderBottom: `1px solid ${color.grey}`,
            }),
          }}
        >
          <ProductDetails product={product} />

          {product.children.length > 0 && (
            <View style={{ paddingLeft: 20 }}>
              {product.children.map((childProduct) => (
                <ProductDetails key={childProduct.id} product={childProduct} disableItem />
              ))}
            </View>
          )}
        </View>
      ))}
    </View>
  );
};

export default ProductsSection;
